export const User_Roles = {
    Full_Access: 'full_access',
    Read_Only: 'read_only',
    Read_Write: 'read_write',
    Owner: 'owner',
    SuperAdmin:'super_admin',
    Admin:'admin'
}